import { Box, Button, Grid } from '@mui/material'
import { Item } from '../../../../../common/snippets'
import { clickElement, navigation3 } from '../../../../../common/helper'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import DownloadIcon from '@mui/icons-material/Download';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';
import ReactHtmlTableToExcel from 'react-html-table-to-excel'

const OtherConfigCommonBottom = (props) => {
  const { onSave, handleBack, printClick, setSearchResult, fileName,hideExcelPdfPrint=false } = props
  return (
    <>
      <Grid container className='reportButton' sx={{ padding: '9px 16px 9px 16px', paddingBottom: '8px', paddingTop: '14px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '10px' }}>
        <Grid item md={1.2}  >
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="outlined" id='cancelBtn'
              sx={{
                width: '100%',
                'svg': {
                  color: '#FE5200 !important', // Initial color for the SVG (icon)
                },
                '&:hover': {
                  'svg': {
                    color: '#FFF !important', // Color on hover for the SVG (icon)
                  },
                },
              }} className="receiveitembtn"
              startIcon={<FontAwesomeIcon icon={faXmark} />}
              onClick={() => {
                handleBack()
              }}
              onKeyDown={(e) => {
                navigation3(e, "pdfBtn", 'cancel_amin', () => { })
              }}
            >
              CANCEL
            </Button>
          </Item>
        </Grid>
        {
          !hideExcelPdfPrint && <>
            <Grid item md={1}  >
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  id='pdfBtn'
                  sx={{
                    width: '100%',
                    'svg': {
                      color: '#FE5200 !important', // Initial color for the SVG (icon)
                    },
                    '&:hover': {
                      'svg': {
                        color: '#FFF !important', // Color on hover for the SVG (icon)
                      },
                    },
                  }}
                  className="receiveitembtn"
                  startIcon={<DownloadIcon sx={{
                    color: '#FE5200 !important',
                    '&:hover': {
                      color: 'white !important',  // Change button text and icon color to white on hover
                      borderColor: 'white !important',
                      '& .MuiSvgIcon-root': {
                        color: 'white !important',
                      }  // Optional: Change border color to white on hover
                    },
                  }} />} // Add the icon here
                  onClick={() => {
                    setSearchResult(false);
                    printClick(true)
                  }}
                  onKeyDown={(e) => {
                    navigation3(e, "printBtn", 'cancelBtn', () => { })
                  }}
                >
                  PDF
                </Button>
              </Item>
            </Grid>
            <Grid item md={1}  >
              <Box >
                <Button
                  variant="outlined"
                  onClick={(e) => { clickElement('xls-buttons-dispatch') }}
                  onKeyDown={(e) => navigation3(e, 'multi_cargo_service_type', 'load_btn', () => { })}
                  id={'excel_btn'}
                  startIcon={<svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM6.08203 9.77344L7.5 11.8008L8.91797 9.77344C9.21484 9.34766 9.80078 9.24609 10.2227 9.54297C10.6445 9.83984 10.75 10.4258 10.4531 10.8477L8.64453 13.4375L10.457 16.0234C10.7539 16.4492 10.6523 17.0312 10.2266 17.3281C9.80078 17.625 9.21875 17.5234 8.92188 17.0977L7.5 15.0703L6.08203 17.0977C5.78516 17.5234 5.19922 17.625 4.77734 17.3281C4.35547 17.0312 4.25 16.4453 4.54688 16.0234L6.35547 13.4375L4.54297 10.8516C4.24609 10.4258 4.34766 9.84375 4.77344 9.54688C5.19922 9.25 5.78125 9.35156 6.07812 9.77734L6.08203 9.77344Z" fill="#FE5200" />
                  </svg>}
                  sx={{ width: '100%', paddingY: '6px !important' }}
                  className="btn cancel-btn"
                >
                  EXCEL
                </Button>
                <ReactHtmlTableToExcel
                  id="xls-buttons-dispatch"
                  table={`table-to-xls1`}
                  filename={fileName}
                  sheet="sheet 1"
                  buttonText="EXPORT AS EXCEL"
                  className="excel-button"
                />
              </Box>
            </Grid>
            <Grid item md={1}  >
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button variant="outlined" id='printBtn'
                  sx={{
                    width: '100%',
                    'svg': {
                      color: '#FE5200 !important', // Initial color for the SVG (icon)
                    },
                    '&:hover': {
                      'svg': {
                        color: '#FFF !important', // Color on hover for the SVG (icon)
                      },
                    },
                  }} className="receiveitembtn"
                  startIcon={
                    <PrintIcon sx={{
                      color: '#FE5200 !important',  // Default color for print icon
                      '&:hover': {
                        color: 'white !important', // Change color to white on hover
                      },
                    }} />
                  }
                  onClick={() => {
                    printClick(false)
                  }}
                  onKeyDown={(e) => {
                    navigation3(e, "saveBtn", 'pdfBtn', () => { })
                  }}
                >
                  PRINT
                </Button>
              </Item>
            </Grid>
          </>
        }
        <Grid item md={1}  >
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" id='saveBtn' style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
              startIcon={
                <SaveIcon sx={{
                  color: 'white !important',  // Default color for print icon
                }} />
              }
              onClick={() => {
                onSave()
              }}
              onKeyDown={(e) => {
                navigation3(e, "CRP-Checkbox", 'cancelBtn', () => { })
              }}
            >
              Save
            </Button>
          </Item>
        </Grid>
      </Grid>
    </>
  )
}

export default OtherConfigCommonBottom
